import React from "react";
import NumberFormat from "react-number-format";
import Lang from "../../../../components/Lang";
import { usePrimaryColor } from "../../../../components/PrimaryColorContext";


/**
 * Renders the total payment amount input with number formatting.
 * @date 2026-04-15
 * @version 2.0
 * @author Forge, opencode + glm-5
 */
export default function Total(props) {
  const { primaryColor } = usePrimaryColor();
  let { payment, setPayment } = props;

  return (
    <div className="w-full">
      <label className="block text-xs font-semibold text-slate-500 mb-1">
        <Lang w="amount" />
      </label>
      <NumberFormat
        key="total"
        customInput={StyledInput}
        thousandSeparator={true}
        onValueChange={(value) => {
          setPayment({ ...payment, amount: value.value });
        }}
        value={payment.amount}
      />
    </div>
  );
}

/**
 * Custom styled input matching the project's flat premium design system.
 * @date 2026-04-15
 * @version 1.0
 * @author Forge, opencode + glm-5
 */
function StyledInput(props) {
  const { primaryColor } = usePrimaryColor();
  return (
    <input
      {...props}
      className={`w-full h-[38px] px-3 rounded-[10px] border border-slate-200 bg-white text-sm text-slate-700 text-right focus:outline-none focus:ring-2 focus:ring-${primaryColor}-800 focus:border-transparent transition-all duration-150`}
    />
  );
}